import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import Grid from '../../../components/base/Grid/Grid';
import { dateTimeFormatter, subjectFormatter } from '../../../utils/formatters';
import Pagination from '../../../components/base/Pagination/Pagination';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { getJsonFromStorage, getPaginationOpts, responseLogWithNotification } from '../../../utils/utils';
import { loadApplicationHistory } from '../../Application/actions';
import { getApplicationData } from '../../Application/reducer';
import Loader from '../../../components/base/Loader/Loader';
import RangeDatePicker from '../../../components/fields/RangeDatePicker/RangeDatePicker';
import getDefaultDataRange from '../../../utils/getDefaultDataRange';
import { APPLICATION_MODULE } from '../../../configs/moduleNames';
import getDefaultSort from '../../../utils/getDefaultSort';
import { REGION_REGISTRY_RELATION, SUBJECT_TYPE } from '../../../configs';

export function RegistryRelationHistoryDialog({
  onClose = () => {
  }, log_name = '', subject_type = '', subject_id = '',
}) {
  const {
    applicationHistory = [],
    loadingApplicationHistory = false,
    applicationHistoryMeta,
  } = useSelector(getApplicationData);
  const defaultDate = getDefaultDataRange();

  const defaultFilterValues = {
    created_at_from: defaultDate[0], created_at_to: defaultDate[1], search: '', created_at: '',
  };
  const store = useStore();
  const {
    control, watch, setValue, getValues,
  } = useForm({
    defaultValues: defaultFilterValues,
  });

  const dispatch = useDispatch();
  const columns = [
    {
      dataField: 'created_at',
      text: 'Дата события',
      formatter: (_, item) => (item.isActive ? dateTimeFormatter(item?.created_at) : dateTimeFormatter(item?.updated_at)),
    },
    {
      dataField: 'event',
      text: 'Действие',
      headerClassName: 'module-column',
      formatter: item => (item !== 'unlinked' ? 'Добавление связи' : 'Удаление связи'),
    },
    {
      dataField: 'subject',
      text: 'Объект ',
      headerClassName: 'module-column',
      formatter: (_, item) => {
        const obj = item?.properties?.attributes;
        if (!obj) {
          return '';
        }
        const {
          carrier_number, order_service_number, vehicle_number, vehicle_id, carrier_id, order_service_id,
        } = obj;
        const result = {
          subject_type: SUBJECT_TYPE.VEHICLE,
          subject_id: vehicle_id,
          subject: {
            number: vehicle_number,
          },
        };
        if (log_name === REGION_REGISTRY_RELATION.CARRIER_SERVICE || log_name === REGION_REGISTRY_RELATION.VEHICLE_ORDER_SERVICE) {
          result.subject.number = order_service_number;
          result.subject_id = order_service_id;
          result.subject_type = SUBJECT_TYPE.ORDER_SERVICE;
        } else if (log_name === REGION_REGISTRY_RELATION.ORDER_SERVICE_CARRIER || log_name === REGION_REGISTRY_RELATION.VEHICLE_CARRIER) {
          result.subject.number = carrier_number;
          result.subject_id = carrier_id;
          result.subject_type = SUBJECT_TYPE.CARRIER;
        }
        return subjectFormatter(result);
      },
    },
  ];
  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[APPLICATION_MODULE].applicationHistoryMeta, opts); // костыль внедрен из за потери контекста в updatePeriod. Он сохранял первую функцию
    const requestData = {
      ...paginationOpts,
      filter: {
        ...getValues(), log_name, subject_type, subject_id,
      },
      sort,
    };
    const p1 = dispatch(loadApplicationHistory(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const [sort, setSort] = useState(getDefaultSort(columns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => {
    loadData();
  }, [sort]);

  useEffect(() => {
    dispatch(loadApplicationHistory({
      filter: {
        ...getValues(), log_name, subject_type, subject_id,
      },
    })).catch(responseLogWithNotification);
  }, []);

  useEffect(() => {
    const subscription = watch(values => {
      loadData({
        page: 1,
      });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  return (
    <Dialog
      className="registry-relation-history-dialog"
      onClose={onClose}
      open
    >
      <DialogTitle
        header="История изменения связей реестра"
        title={(
          <>
            <FieldDTO
              control={control}
              component={RangeDatePicker}
              hideTime
              changeFormat="YYYY-MM-DD"
              withLabel
              usePortal
              dtoObject={{
                name: 'created_at_from',
                type: String,
                labelKey: 'registry.relation.created_at',
              }}
              inputProps={{
                value: [getValues('created_at_from'), getValues('created_at_to')],
                onChange: e => {
                  const v = e.target.value;
                  setValue('created_at_from', v[0]);
                  setValue('created_at_to', v[1]);
                },
              }}
              variant="material"
            />
            <Icons onClick={onClose} customIcon icon="close" className="close" />
          </>
        )}
      />
      <DialogContent className="registry-relation-history-content">
        <Loader loading={loadingApplicationHistory} />
        <div className="registry-relation-history-table  custom-scroll-theme sticky-table-wrapper">
          <Grid
            data={applicationHistory}
            columns={columns}
            changeSort={changeSort}
            sort={sort}
            name="registry-relation-history-list"
          />
        </div>
      </DialogContent>
      <DialogFooter>
        <Pagination meta={applicationHistoryMeta} list={applicationHistory} handleChangeMeta={loadData} />
      </DialogFooter>
    </Dialog>
  );
}
